export class FetchUsersSuccess {
    static readonly type = '[User] FetchUsersSuccess';
}
